import { Component } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { StructureViewerLayer } from 'src/app/shared/structureviewermaps/structureviewerlayers';

@Component({
    selector: 'app-gateways',
    templateUrl: './gateways.component.html',
    styleUrls: ['./gateways.component.scss'],
    standalone: false
})
export class GatewaysComponent {
  constructor() { }

  ngOnInit(): void {
  }
  public Subsets: string[] = [];

  public Columns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Id", "Id"),
    new Datalistviewcolumn("HID", "ChipId"),
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Location", "LocationString"),
    new Datalistviewcolumn("Wake Time", "WakeUpTime"),
    new Datalistviewcolumn("Sleep Time", "SleepTime"),
  ];

  public StructureViewerLayers: StructureViewerLayer[] = [new StructureViewerLayer("ParkingLot", null, false, true), new StructureViewerLayer("ParkingLevel"), new StructureViewerLayer("ParkingSpace"), new StructureViewerLayer("GatewayConfiguration", "Gateways") ]
}
